import { io } from 'socket.io-client';
import { ISocketNotification } from '@/modules/Sockets/Sockets.types.ts';
import RefreshTokenSingleton from '@/utils/api/RefreshTokenSingleton.ts';

const socket = io(import.meta.env.VITE_API_HOST as string, {
    path: '/socket.io',
    transports: ['websocket']
});

const handleTokenRefresh = async () => {
    if (!RefreshTokenSingleton.isPending) {
        await RefreshTokenSingleton.refreshToken();
    }
};

socket.on('connect_error', (error) => {
    console.log('connect_error', error);
});

socket.on('reconnect', (event) => {
    console.log('reconnect', event);
});

socket.on('notification', () => {
    /* placeholder */
});

socket.on('exception', (event: ISocketNotification) => {
    console.log('Received exception:', event);
});

socket.on('auth', (event: ISocketNotification) => {
    console.log('Received auth:', event);
    if (
        event.event_type === 'auth' &&
        ['auth_expiring', 'auth_expired'].includes(event.data.message_type)
    ) {
        handleTokenRefresh();
    }
});

export default socket;
